//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import SetupFacebook from '../facebook/SetupFacebook';
import SetupChat from '../facebook/SetupChat';
import OverviewOfferCard from './OverviewOfferCard';


export default {
	name: 'OverviewTop',
	components: {
		SetupFacebook,
		SetupChat,
		OverviewOfferCard,
	},
	computed: {
		...mapState('auth', ['currentUser']),
	},
};
